import { MatDialogRef } from '@angular/material/dialog';
import { TransportPlannerProfileDetails } from '../models';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

export class TransportPlannerProfileItemBriefLoad {
  public static readonly type = '[TransportPlannerProfileItemBrief] Load';

  constructor(public payload: number) {}
}

export class TransportPlannerProfileItemBriefSave {
  public static readonly type = '[TransportPlannerProfileItemBrief] Save';

  constructor(public payload: TransportPlannerProfileDetails) {}
}

export class TransportPlannerProfileItemBriefClone {
  public static readonly type = '[TransportPlannerProfileItemBrief] Clone';

  constructor(public payload: TransportPlannerProfileDetails) {}
}

export class TransportPlannerProfileItemBriefDelete {
  public static readonly type = '[TransportPlannerProfileItemBrief] Delete';

  constructor(public payload: { dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>; profileId: number }) {}
}

export class TransportPlannerProfileItemBriefInitialState {
  public static readonly type = '[TransportPlannerProfileItemBrief] Set Initial State';
}
